<template>
  <v-snackbar
    v-model="snackbarStore.isVisible"
    :color="snackbarStore.color"
    :timeout="snackbarStore.timeout"
    :location="snackbarStore.position"
    dark
  >
    {{ snackbarStore.message }}
    <template v-slot:action="{ attrs }">
      <v-btn text v-bind="attrs" @click="snackbarStore.closeSnackbar"> Close </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { useSnackbarStore } from '@/stores/snackbar.ts'
export default defineComponent({
  name: 'GlobalSnackbar',
  setup() {
    const snackbarStore = useSnackbarStore()
    return { snackbarStore }
  },
})
</script>
